import React from 'react';
import moment from 'moment';
import { get } from 'lodash';
import { unescapeHTML } from 'underscore.string';
import { unescapeSpecialChars } from 'helpers/helper_functions';
import {
  phoneFormatterInternational,
  phoneFormatterUS,
} from 'utils/formatters/Phone';
import { REGIONS } from 'constants/Regions';
import USER_TYPES from 'constants/UserTypes';

const formattedPhoneNumber = (clean) => {
  if (clean.length === 10 && clean[0] !== '1')
    return `${clean.substring(0, 3)}-${clean.substring(3, 6)}-${clean.substring(
      6,
      10,
    )}`;
  if (clean.length === 11 && clean[0] === '1')
    return `${clean.substring(0, 1)}-${clean.substring(1, 4)}-${clean.substring(
      4,
      7,
    )}-${clean.substring(7, 11)}`;
  return clean;
};

const getUnixtime = (id) => {
  return parseInt(id.substring(0, 8), 16);
};

export const masterAccountNameRenderer = (params) => {
  const {
    data: { _id },
    value,
  } = params;
  if (!value) return null;

  return (
    <div>
      <button onClick={() => params.onClick(_id)}>
        {' '}
        {unescapeSpecialChars(value)}{' '}
      </button>
    </div>
  );
};

export const companyNameRenderer = (params) => {
  const {
    data: { _type, authorized, _id, mvp },
    value,
  } = params;
  if (!value) return null;
  return (
    <div className="relative w-max">
      <div> {unescapeSpecialChars(value)} </div>
      {mvp ? (
        <img
          src="/img/cargomatic-circle.png"
          className="absolute -top-2 right-0 w-4"
          alt="MVP"
        />
      ) : null}
    </div>
  );
};

export const nameRenderer = (params) => {
  const {
    data: { _type, authorized, _id },
    value,
  } = params;
  if (!value) return null;

  let linkColor = 'DodgerBlue';
  if (['Driver', 'Carrier'].indexOf(_type) > -1 && !authorized) {
    linkColor = 'red';
  }
  // We're passing in the optimized name, and unescapeHTML doesn't work with upper case HTML entity names
  return (
    <div>
      <button style={{ color: linkColor }} onClick={() => params.onClick(_id)}>
        {' '}
        {unescapeSpecialChars(value)}{' '}
      </button>
    </div>
  );
};

export const nameCompanyNameFormatter = (params) => {
  if (params.data._type === USER_TYPES.WAREHOUSE) {
    return unescapeHTML(params.data.company_name || '');
  }
  return unescapeHTML(params.data.company_name || params.data.name || '');
};

export const phoneFormatter = (params) => {
  const phoneParam = get(params, 'data.phone');
  const value = get(params, 'value');
  const phone = value ?? phoneParam;
  if (!phone) return '';

  // switch by region in case we expand to another region later
  switch (REGION_CODE) {
    case REGIONS.AP:
      return phoneFormatterInternational(phone);
    case REGIONS.US:
      return phoneFormatterUS(phone);
    default:
      return phoneFormatterUS(phone);
  }
};

export const dateFormatter = (params) => {
  const fieldName = params.colDef.field;
  if (params.data[fieldName]) {
    return moment(params.data[fieldName]).format('L');
  }
  if (fieldName === 'date_created') {
    return moment.unix(getUnixtime(params.data._id)).format('L');
  }
  return '';
};

export const dateTimeFormatter = (params) => {
  const fieldName = params.colDef.field;
  if (params.data[fieldName]) {
    return moment(params.data[fieldName]).format('L HH:mm');
  }
  return '';
};

export const markupFormatter = (params) => {
  if (typeof params.data.markup === 'number') {
    return parseFloat(params.data.markup.toPrecision(4));
  }
  return params.data.markup;
};

export const tariffFormatter = (params) => {
  if (params.data.tariffs) {
    return params.data.tariffs
      .map((tariff) => {
        return tariff.name;
      })
      .join('\n');
  }
  return '';
};

export const authorizedFormatter = (params) => {
  if (params?.data?._type !== 'Carrier') return '';
  return params?.data?.authorized ? 'TRUE' : 'FALSE';
};

export const trainedFormatter = (params) => {
  if (params?.data?._type !== 'Carrier') return '';
  return params?.data?.status || '';
};

export const tariffRenderer = (params) => {
  if (params.value) {
    const tariffs = params.value.split('\n');
    const tariffList = tariffs.map((tariff, idx) => (
      <span key={idx}>
        {tariff}
        <br />
      </span>
    ));
    return <span> {tariffList} </span>;
  }
  return null;
};
